import { useEffect } from 'react';

export function useSyncSectionHash(activeSectionId: string | null) {
  useEffect(() => {
    if (!activeSectionId) return;
    window.history.replaceState(null, '', `#${activeSectionId}`);
  }, [activeSectionId]);
}
